export default __webpack_public_path__ + "static/media/lca-footer.1dbf4c9c.svg";